/* tslint:disable */
export enum UserCardFieldType {
  Text = 1,
  Logical = 2,
  Selectable = 3,
  Password = 4,
}
